/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCelebrationIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-celebration"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.77 20.68L5.97 8.88Q6.13 8.45 6.47 8.22Q6.83 8 7.22 8Q7.47 8 7.71 8.09Q7.95 8.18 8.15 8.38L15.75 15.97Q15.95 16.18 16.04 16.41Q16.13 16.65 16.13 16.9Q16.13 17.3 15.9 17.65Q15.68 18 15.25 18.15L3.45 22.35Q3.05 22.5 2.69 22.41Q2.33 22.32 2.08 22.05Q1.82 21.77 1.74 21.43Q1.65 21.07 1.77 20.68ZM24.02 6.7Q23.75 6.97 23.38 6.97Q23 6.97 22.73 6.7L22.63 6.6Q22.3 6.28 21.88 6.28Q21.45 6.28 21.13 6.6L15.93 11.8Q15.65 12.07 15.28 12.07Q14.9 12.07 14.63 11.8Q14.35 11.53 14.34 11.14Q14.32 10.75 14.6 10.47L19.82 5.25Q20.7 4.38 21.9 4.38Q23.1 4.38 23.98 5.25L24.1 5.38Q24.38 5.65 24.35 6.04Q24.32 6.42 24.02 6.7ZM10.07 3.48Q10.35 3.2 10.72 3.21Q11.1 3.23 11.38 3.5L11.38 3.5Q12.18 4.3 12.18 5.42Q12.18 6.55 11.38 7.35L11.38 7.35Q11.13 7.6 10.76 7.59Q10.4 7.58 10.05 7.22Q9.78 6.95 9.79 6.6Q9.8 6.25 10.07 6L10.07 6Q10.32 5.75 10.32 5.42Q10.32 5.1 10.07 4.85L10.05 4.83Q9.78 4.55 9.79 4.15Q9.8 3.75 10.07 3.48ZM14.4 1.13Q14.68 0.85 15.07 0.86Q15.47 0.88 15.75 1.15L16.82 2.25Q17.7 3.13 17.7 4.33Q17.7 5.53 16.82 6.4L13.68 9.55Q13.4 9.82 13.03 9.82Q12.65 9.82 12.38 9.55Q12.1 9.28 12.09 8.89Q12.07 8.5 12.35 8.22L15.53 5.05Q15.85 4.72 15.85 4.3Q15.85 3.88 15.53 3.55L14.4 2.45Q14.13 2.17 14.13 1.79Q14.13 1.4 14.4 1.13ZM23.63 14.05Q23.35 14.32 22.98 14.32Q22.6 14.32 22.32 14.05L20.88 12.6Q20.63 12.35 20.27 12.35Q19.93 12.35 19.68 12.6L18.18 14.07Q17.9 14.35 17.52 14.34Q17.15 14.32 16.88 14.05Q16.6 13.78 16.59 13.39Q16.57 13 16.85 12.72L18.32 11.25Q19.13 10.45 20.25 10.45Q21.38 10.45 22.18 11.25L23.65 12.72Q23.93 13 23.91 13.39Q23.9 13.78 23.63 14.05Z" fill={color} />
    </svg>
  );
}
